import type { ReactNode } from "react";
import type { EvidenceFocus } from "../../../annotation";
import { classNames } from "../../../../ui/styles/classNames";

interface TextFocusButtonProps {
  /** The statement whose words and line it follows: a line's key, or one a line shows. */
  readonly statementKey: string;
  readonly focus: EvidenceFocus;
  /** Its look, such as a chip's (`chipClassName`). */
  readonly className?: string;
  readonly children: ReactNode;
}

/**
 * Something on a card that stands for a statement, followed into the text as the statement's own
 * line is (O-1, AB-6 "follow a statement to its text"): pointing at it highlights the statement's
 * words and line, a click keeps them and brings them into view, a second click lets go.
 */
export default function TextFocusButton({ statementKey, focus, className, children }: TextFocusButtonProps) {
  const keys = [statementKey];
  return (
    <button
      type="button"
      aria-pressed={focus.selected.has(statementKey)}
      onMouseEnter={() => { focus.onPoint(keys); }}
      onMouseLeave={() => { focus.onPoint(null); }}
      onFocus={() => { focus.onPoint(keys); }}
      onBlur={() => { focus.onPoint(null); }}
      onClick={() => { focus.onSelect(keys); }}
      className={classNames("cursor-pointer text-left", focus.highlighted.has(statementKey) && "app-evidence-focused", className)}
    >
      {children}
    </button>
  );
}
